import React from "react";

import { dFlex, flex1 } from "./styles";
import OnePanel from "./OnePanel";
import Title from "./Title";
import Text from "./Text";

const GradesRanks = ({ round }) => (
  <OnePanel title="Metrics That Drive Your Grade & Ranking">
    <div style={{ ...dFlex, alignItems: "flex-start" }}>
      <div style={flex1}>
        <Text>
          For Year{" "}
          {round <= 2 ? "1 through 2" : round === 3 ? "3" : "4 and beyond"},
          these are 4 metrics that will drive your team grade &amp; ranking
        </Text>
      </div>
      <div style={{ ...flex1, textAlign: "center" }}>
        {round <= 2 ? (
          <fragment>
            <Title>1. Market Share</Title>
            <Title>2. Net Revenues</Title>
            <Title>3. Gross Margins</Title>
            <Title>4. Share Price</Title>
          </fragment>
        ) : round === 3 ? (
          <fragment>
            <Title>1. Net Revenues</Title>
            <Title>2. Gross Margins</Title>
            <Title>3. Return on Assets (ROA)</Title>
            <Title>4. Return on Equity (ROE)</Title>
          </fragment>
        ) : (
          <fragment>
            <Title>1. Return on Assets (ROA)</Title>
            <Title>2. Return on Equity (ROE)</Title>
            <Title>3. Earnings Per Share</Title>
            <Title>4. Share Price</Title>
          </fragment>
        )}
      </div>
    </div>
  </OnePanel>
);

export default GradesRanks;



// WEBPACK FOOTER //
// ./src/components/analysis/GradesRanks.js